class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimer = null;
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.clearHoverCloseTimer = this.clearHoverCloseTimer.bind(this);

    if (window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.mainDetailsToggle.addEventListener('mouseenter', this.clearHoverCloseTimer);
      this.content.addEventListener('mouseenter', this.clearHoverCloseTimer);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseEnter() {
    this.clearHoverCloseTimer();

    if (this.mainDetailsToggle.open) return;

    const openMenus = this.header?.querySelectorAll('header-menu details[open]') || [];
    openMenus.forEach((menu) => {
      if (menu !== this.mainDetailsToggle) {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.clearHoverCloseTimer();
    this.hoverCloseTimer = window.setTimeout(() => {
      this.close();
    }, 180);
  }

  clearHoverCloseTimer() {
    if (!this.hoverCloseTimer) return;

    window.clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = null;
  }
}

customElements.define('header-menu', HeaderMenu);
